import { values, includes, trimStart } from 'lodash';
import { getTopology } from '../store/topology/topology-selectors';
import { INSTANCE_ID_WIX } from '@wix/communities-universal/dist/src/constants/wix-blogs';
import { isSite } from '../selectors/view-mode-selectors';
import { BLOG_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { BLOG_POST_PAGE_ID } from '@wix/communities-blog-client-common/dist/src/constants/component-ids';
import Wix from '../services/wix-sdk-polyfill';

export const navigateWithinBlog = path => (dispatch, getState, { wixCodeApi }) => {
  const { baseUrl, sectionUrl } = getTopology(getState());
  const sectionPath = sectionUrl.replace(baseUrl, '');
  return wixCodeApi.location.to(`${sectionPath}${path}`);
};

export const navigateWithinPostPage = path => (dispatch, getState, { wixCodeApi }) => {
  const { baseUrl, postPageSectionUrl: sectionUrl } = getTopology(getState());
  const sectionPath = sectionUrl.replace(baseUrl, '');
  return wixCodeApi.location.to(`${sectionPath}${path}`);
};

export const navigateProGalleryWithinPostPage = path => (dispatch, getState, { wixCodeApi, appParams }) => {
  const state = getState();
  const { baseUrl, postPageSectionUrl: sectionUrl } = getTopology(state);

  if (!isSite(state)) {
    return Wix.Utils.navigateToSection(
      {
        appDefinitionId: BLOG_APP_ID,
        sectionId: BLOG_POST_PAGE_ID,
        shouldRefreshIframe: false,
      },
      trimStart(path, '/'),
    );
  }

  // Temporary hack for marketing sites, because wix code navigation doesn't work properly
  if (includes(values(INSTANCE_ID_WIX), appParams.instanceId)) {
    return wixCodeApi.location.to(`${baseUrl}${path}`);
  }

  const sectionPath = sectionUrl.replace(baseUrl, '');
  return wixCodeApi.location.to(`${sectionPath}${path}`);
};
